import {baseNewImagesPath, baseDashboardImagesPath} from "../../assets";

export const bathTubThumbnail  = `${baseNewImagesPath}images/bv_icons_new/Icons_Bathtub.svg`;
export const ceilingThumbnail  = `${baseNewImagesPath}images/bv_icons_new/Icons_Ceiling.svg`;
export const floorThumbnail    = `${baseNewImagesPath}images/bv_icons_new/Icons_Floor.svg`;
export const showerThumbnail   = `${baseNewImagesPath}images/bv_icons_new/shower_icon_new.svg`;
export const showerAccessoriesThumbnail   = `${baseNewImagesPath}images/bv_icons_new/accesories.svg`;
export const showerOLDThumbnail = `${baseNewImagesPath}images/bv_icons_new/Icons_Shower.svg`;
export const showerTubComboThumbnail = `${baseNewImagesPath}images/bv_icons_new/shower-tub_icon.svg`;
export const custom60in30X8Shower  = `${baseNewImagesPath}images/bv_icons_new/custom-a-60in-30x8.svg`;
export const custom30in30X8Shower  = `${baseNewImagesPath}images/bv_icons_new/custom-a-30in-30x8.svg`;
export const custom60in15X4Shower  = `${baseNewImagesPath}images/bv_icons_new/custom-b-60in-15x4.svg`;
export const custom30in15X4Shower  = `${baseNewImagesPath}images/bv_icons_new/custom-b-30in-15x4.svg`;
export const custom60inPonyShower  = `${baseNewImagesPath}images/bv_icons_new/custom-c-60in-pony.svg`;
export const custom30inPonyShower  = `${baseNewImagesPath}images/bv_icons_new/custom-c-30in-pony.svg`;
export const toiletThumbnail   = `${baseNewImagesPath}images/bv_icons_new/toilet_backend.svg`;
export const vanityThumbnail   = `${baseNewImagesPath}images/bv_icons_new/Icons_Vanity-05.svg`;
export const wallsThumbnail    = `${baseNewImagesPath}images/bv_icons_new/Icons_Wall.svg`;
export const windowThumbnail   = `${baseNewImagesPath}images/bathroom-icons/Window_Coverings.svg`;
export const largeLayout       = `${baseNewImagesPath}images/bv-assets/thumbnail-config01.png`;
export const smallLayout       = `${baseNewImagesPath}images/bv-assets/thumbnail-config02.png`;
export const largeLayoutShadow = `${baseNewImagesPath}images/bv-assets/Lg-Global-Shadow.png`;
export const smallLayoutShadow = `${baseNewImagesPath}images/bv-assets/Sm-Global-Shadow.png`;
export const shower30inWallShadow = `${baseNewImagesPath}images/bv-assets/Lg-Ex R-Shadow Overlay 30X45[For=LG-Ex-R].png`;
export const floorPlaceholder     = `${baseNewImagesPath}images/bv-assets/placeholders/All-Floor-Placeholder.png`;
export const ceilingPlaceholder   = `${baseNewImagesPath}images/bv-assets/placeholders/All-Ceiling-Placeholder.png`;

export const showerWallSmallRoomPlaceholder       = `${baseNewImagesPath}images/bv-assets/placeholders/SM-Shower Wall-Placeholder[For=Shower=(Custom_Kit1_Kit3_Steam)=ShowerSize=30in].png`;
export const showerWallSmallRoomPlaceholder60in   = `${baseNewImagesPath}images/bv-assets/placeholders/SM-Shower Wall-Placeholder[For=Shower=(Custom_Kit1_Kit3_Steam)=ShowerSize=60in].png`;
export const showerFloorSmallRoomPlaceholder      = `${baseNewImagesPath}images/bv-assets/placeholders/SM-ShowerFloor-Placeholder[For=Shower=(Custom)=ShowerSize=30in].png`;
export const showerFloorSmallRoomPlaceholder60in  = `${baseNewImagesPath}images/bv-assets/placeholders/SM-ShowerFloor-Placeholder[For=Shower=(Custom)=ShowerSize=60in].png`;
export const showerPanSmallRoomPlaceholder        = `${baseNewImagesPath}images/bv-assets/placeholders/SM-ShowerPan-Placeholder[For=Shower=(Custom)=ShowerSize=30in].png`;
export const showerPanSmallRoomPlaceholder60in    = `${baseNewImagesPath}images/bv-assets/placeholders/SM-ShowerPan-Placeholder[For=Shower=(Custom)=ShowerSize=60in].png`;

export const LayoutThumbnails = {
  Large: largeLayout,
  Small: smallLayout,
};

export const homePage = {
  vanity_cabinet: `${baseNewImagesPath}images/home/section-images/vanity-bases.jpg`,
  vanity: `${baseNewImagesPath}images/home/section-images/vanity-bases.jpg`,
  vanity_countertop: `${baseNewImagesPath}images/home/section-images/countertops.jpg`,
  vanity_sink: `${baseNewImagesPath}images/home/section-images/sinks.jpg`,
  vanity_faucet: `${baseNewImagesPath}images/home/section-images/faucets.jpg`,
  vanity_mirror: `${baseNewImagesPath}images/home/section-images/mirrors.jpg`,
  vanity_backsplash: `${baseNewImagesPath}images/home/section-images/backsplash.png`,
  vanity_handle: `${baseNewImagesPath}images/home/section-images/handle.png`,
  shower_body: `${baseNewImagesPath}images/home/section-images/shower-glass.jpg`,
  shower_fixture: `${baseNewImagesPath}images/home/section-images/shower-fixtures.jpg`,
  shower_interior_wall: `${baseNewImagesPath}images/home/section-images/shower-wall.jpg`,
  shower_interior_wall_accent: `${baseNewImagesPath}images/home/section-images/shower-accent.png`,
  shower_floor: `${baseNewImagesPath}images/home/section-images/shower-flooring.jpg`,
  shower_door: `${baseNewImagesPath}images/home/section-images/shower-door.png`,
  shower_pan: `${baseNewImagesPath}images/home/section-images/shower-pan.png`,
  shower_pan_combo: `${baseNewImagesPath}images/home/section-images/shower-pan.png`,
  shower_door_handle: `${baseNewImagesPath}images/home/section-images/shower-handles.jpg`,
  threshold: `${baseNewImagesPath}images/home/section-images/threshold.png`,
  bathtub: `${baseNewImagesPath}images/home/section-images/bathtubs.jpg`,
  bathtub_fixture: `${baseNewImagesPath}images/home/section-images/bathtub-fixtures.jpg`,
  toilet: `${baseNewImagesPath}images/home/section-images/toilets.jpg`,
  floor: `${baseNewImagesPath}images/home/section-images/flooring.jpg`,
  ceiling: `${baseNewImagesPath}images/home/section-images/ceilings.jpg`,
  window: `${baseNewImagesPath}images/home/section-images/window-coverings.jpg`,
  lighting: `${baseNewImagesPath}images/home/section-images/lighting-fixtures.jpg`,
  towel: `${baseNewImagesPath}images/home/section-images/towel-racks.jpg`,
  wall_a: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  wall_b: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  wall_c: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  left_shower_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  right_shower_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  accent_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  pony_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  walls: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  jetted_tub: `${baseNewImagesPath}images/home/section-images/jetted-tub.png`,
  replacement_tub: `${baseNewImagesPath}images/home/section-images/replacement-tub.png`,
  bathtub_liner: `${baseNewImagesPath}images/home/section-images/tub-liner.png`,
  walk_in_tub: `${baseNewImagesPath}images/home/section-images/walk-in-tub.png`,
  //kitchen
  dishwasher: `${baseNewImagesPath}images/home/section-images/dishwasher.png`,
  hood: `${baseNewImagesPath}images/home/section-images/hood.png`,
  fridge: `${baseNewImagesPath}images/home/section-images/fridge.png`,
  range: `${baseNewImagesPath}images/home/section-images/range.png`,
  microwave: `${baseNewImagesPath}images/home/section-images/microwave.png`,
  crown_molding: `${baseNewImagesPath}images/home/section-images/crown-molding.png`,
  left_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  right_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  popout_wall: `${baseNewImagesPath}images/home/section-images/walls.jpg`,
  backsplash: `${baseNewImagesPath}images/home/section-images/backsplash.png`,
  sink: `${baseNewImagesPath}images/home/section-images/sinks.jpg`,
  faucet: `${baseNewImagesPath}images/home/section-images/faucets.jpg`,
  countertop: `${baseNewImagesPath}images/home/section-images/countertops.jpg`,
  center_island_countertop: `${baseNewImagesPath}images/home/section-images/countertops.jpg`,
  center_island_sink: `${baseNewImagesPath}images/home/section-images/sinks.jpg`,
  center_island_faucet: `${baseNewImagesPath}images/home/section-images/faucets.jpg`,
  center_island_cabinet: `${baseNewImagesPath}images/home/section-images/vanity-bases.jpg`,
  center_island_handle: `${baseNewImagesPath}images/home/section-images/handle-kitchen.png`,
  center_island_chairs: `${baseNewImagesPath}images/home/section-images/chairs.png`,
  top_handle: `${baseNewImagesPath}images/home/section-images/handle-kitchen.png`,
  bottom_handle: `${baseNewImagesPath}images/home/section-images/handle-kitchen.png`,
  top_cabinet: `${baseNewImagesPath}images/home/section-images/icon-cabinet-upper.png`,
  bottom_cabinet: `${baseNewImagesPath}images/home/section-images/icon-cabinet-lower.png`,
  cutout: `${baseNewImagesPath}images/home/section-images/cutout.png`,
  cutouts: `${baseNewImagesPath}images/home/section-images/cutout.png`,
  edge_profile: `${baseNewImagesPath}images/home/section-images/edge.png`,
  edge_profiles: `${baseNewImagesPath}images/home/section-images/edge.png`,
  edge: `${baseNewImagesPath}images/home/section-images/edge.png`,
  center_island_edge: `${baseNewImagesPath}images/home/section-images/edge.png`,
  room: `${baseNewImagesPath}images/home/section-images/room.png`,
  kitchen_floor: `${baseNewImagesPath}images/home/section-images/flooring.jpg`,
  walls_ceiling: `${baseNewImagesPath}images/home/section-images/ceilings.jpg`,
};

export const shareImage = {
  Bathroom: "https://qc-cdn.s3.amazonaws.com/social-networks/BathRoomVisualizer_Facebook_QC.jpeg",
  bvLook: "https://qc-cdn.s3.amazonaws.com/social-networks/BathRoomVisualizer_Facebook_Lixil.jpg",
  Kitchen: "https://s3.amazonaws.com/qc-cdn/fabricator-presets-screenshots/cd49f0acc72e40f1a912830cf0385b83.png"
};
export const shareImageRebath = "https://qc-cdn.s3.amazonaws.com/social-networks/BathRoomVisualizer_Facebook_ReBath.jpeg";

const normalizeIconFileName = (featureGroupName) => {
  return ((featureGroupName || ''))
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(".svg", "") + '.svg';
};

const featureGroupNameToIcon = {
  '10 year sealer': 'sealer.svg',
  'cabinet': 'cabinets.svg',
  'top mount sink cutout': 'topmount-sink-cutout.svg',
  'under mount sink cutout': 'undermount-sink-cutout.svg',
  'counter top removal': 'countertop-removal.svg',
  'cooktop cutout': 'range-top-cutout.svg',
  'cutout': 'cutouts.svg',
  'faucet': 'faucets.svg',
  'floor': 'flooring.svg',
  'shower-walls': 'shower-wall.svg',
  'shower walls': 'shower-wall.svg',
  'fixture': 'shower-fixture.svg',
  'range-hood-x': 'range-hood.svg',
  'range-hood-z': 'range-hood.svg',
  'refridgerator': 'refrigerator.svg',
  'removal': 'countertop-removal.svg',
  'room(s) installed': 'room.svg',
  'sink': 'sinks.svg',
  'backsplash-thickness': 'slabs.svg',
  'backsplash thickness': 'slabs.svg',
  'edge': 'edge-profile.svg',
  'island countertop': 'center-island-countertop.svg',
  'hook bag': 'garage-hook.svg',
  'slatwall': 'slat_wall.svg',
  'overhead rack': 'overhead_rack.svg',
  'cabinet leg': 'cabinet_leg.svg',
};

export function getFeatureGroupIconURL(featureGroupName) {
  const name = ((featureGroupName || '')).toLowerCase();
  return (name in featureGroupNameToIcon)
    ? baseDashboardImagesPath + featureGroupNameToIcon[name]
    : baseDashboardImagesPath + normalizeIconFileName(name);
}

export function getFeatureGroupIconStyles(featureGroup, activeTheme) {
  let
    backgroundImage = "",
    backgroundSize = "150%",
    backgroundPosition = "";

  if (!featureGroup.customImageUrl) {
    backgroundImage = getFeatureGroupIconURL(featureGroup.partName, activeTheme);
  } else {
    backgroundImage = featureGroup.customImageUrl;
    if (featureGroup.customImageUrl.includes("backsplash-new")) {
      backgroundSize = "80%";
      backgroundPosition = "left 25% center";
    } else if (featureGroup.customImageUrl.includes("enabled/countertop.svg")) {
      backgroundSize = "" // auto
    }
  }
  if (activeTheme === "caes" || activeTheme === "moderno" || activeTheme === "as") {
    backgroundImage = getDashboardThemeIcon(backgroundImage, activeTheme);
  }
  if (backgroundImage.includes("enabled/top-cabinet.svg")) {
    backgroundSize = "60%"
  } else if (backgroundImage.includes("enabled/bottom-cabinet.svg")) {
    backgroundSize = "80%"
  } else if (backgroundImage.includes("enabled/slabs.svg")) {
    backgroundSize = "90%"
  } else if (backgroundImage.includes("enabled/center-island-countertop.svg")) {
    backgroundSize = "95%"
  } else if (backgroundImage.includes("enabled/garage-hook.svg")) {
    backgroundSize = "65%"
  }
  switch (featureGroup.partId) {
    case "cabinet_leg":
    case "hook_bag":
    case "overhead_rack":
    case "slat_wall":
      backgroundSize = null; // we set it in scss
      break;
    default:
      break;
  }
  return {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize,
    backgroundPosition,
  }
}

export function getDashboardThemeIcon(backgroundImage, activeTheme) {
  const imageSplitted = backgroundImage.split("enabled/");
  if (imageSplitted[1]) {
    backgroundImage = `${baseNewImagesPath}images-${activeTheme}/dashboard-icons/${imageSplitted[1]}`
  }
  return backgroundImage
}


